import { classNames } from "primereact/utils";
import { ReactNode } from "react";
import { SIDEBAR_ACCENT_CLASSNAMES } from "../sidebar.constants";

interface SidebarActionButtonProps {
    label: string;
    icon: ReactNode;
    isCompanyView: boolean;
    onClick: () => void;
}

const SidebarActionButton = (props: SidebarActionButtonProps) => {
    const { label, icon, isCompanyView, onClick } = props;

    const accent = isCompanyView
        ? SIDEBAR_ACCENT_CLASSNAMES.COMPANY
        : SIDEBAR_ACCENT_CLASSNAMES.DEFAULT;

    return (
        <button
            type="button"
            onClick={onClick}
            className={classNames(
                "group relative flex w-full items-center gap-2.5 h-11 md:h-10 px-3 py-2 transition-colors rounded-md text-left cursor-pointer text-text-500",
                accent.hoverBg,
                accent.hoverText
            )}
        >
            <span
                className={classNames(
                    "flex-none text-text-300",
                    accent.iconHover
                )}
            >
                {icon}
            </span>
            <span className="font-normal">{label}</span>
        </button>
    );
};

export default SidebarActionButton;
